import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface FilterUpgradeTooltipProps {
  active: boolean
  children: React.ReactNode
  align?: 'start' | 'center' | 'end'
}

// Wraps a disabled filter trigger with a rich tooltip prompting an upgrade.
// `span` wrapper keeps hover events firing even when the inner button is
// `disabled` (a native disabled control swallows pointer events).
const FilterUpgradeTooltip = ({ active, children, align = 'start' }: FilterUpgradeTooltipProps) => {
  const navigate = useNavigate()

  if (!active) return <>{children}</>

  return (
    <Tooltip delayDuration={100}>
      <TooltipTrigger asChild>
        <span
          className="inline-flex cursor-not-allowed"
          tabIndex={0}
          aria-disabled="true"
          aria-label="Upgrade to Enterprise to use this control"
        >
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        align={align}
        className="flex w-[333px] max-w-none flex-col gap-2 rounded-lg bg-card p-3 text-left font-[Figtree,sans-serif] shadow-md"
      >
        <div className="text-base font-semibold leading-6 text-muted-foreground">Upgrade to Enterprise</div>
        <p className="text-[15px] leading-5 text-muted-foreground">
          Unlock additional usage data, team management tools, and security permissions across your organization.
        </p>
        <Button
          size="sm"
          onClick={() => navigate('/app/settings/billing')}
          className="self-start text-[15px] font-semibold leading-5"
        >
          See plans
        </Button>
      </TooltipContent>
    </Tooltip>
  )
}

export default FilterUpgradeTooltip
